export default "__VITE_ASSET__DUlAhcMa__"